module.exports = __webpack_public_path__ + "static/media/united_card_2.6bc7a001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/united_card_2.jpg
// module id = 523
// module chunks = 0